module.exports = __webpack_public_path__ + "img/pencil.bc6b314f.svg";